const analyticsUtils = {
    getOneYearMonthRanges: (date = new Date()) => {
        const ranges = [];
        date.setDate(1);
        const endDate = new Date(date.valueOf());
        const startDate = new Date(date.valueOf());
        startDate.setMonth(startDate.getMonth() - 11);

        while (startDate <= endDate) {
            ranges.push([startDate.getFullYear(), startDate.getMonth()]);
            startDate.setMonth(startDate.getMonth() + 1);
        }

        return ranges;
    },
    createDateFromYearMonth(year, month) {
        const date = new Date();
        date.setFullYear(year);
        date.setMonth(month, 1);
        return date;
    },
};

export default analyticsUtils;
